export const userColumns = [
  {
    field: 'user_photo',
    headerName: 'User Photo',
    flex: 1,
    align: 'center',
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
        </div>
      );
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
  },
  {
    field: 'username',
    headerName: 'Username',
    flex: 1,
  },
  {
    field: 'photos_nr',
    headerName: 'Photos',
    flex: 1,
  },
  {
    field: 'timeStamp',
    headerName: 'Created on',
    flex: 1,
    renderCell: (params) => {
      return <div> {params.row.timeStamp?.toDate().toString().substring(0, 25)}</div>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    align: 'center',
    renderCell: (params) => {
      return <div className={`cellWithStatus ${params.row.status}`}> {params.row.status ? 'Online' : 'Offline'}</div>;
    },
  },
];

export const phoneColumns = [
  {
    field: 'user_photo',
    headerName: 'User Photo',
    flex: 1,
    align: 'center',
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img className="cellImg" src={params.row.img} alt="avatar" />
        </div>
      );
    },
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
  },
  {
    field: 'username',
    headerName: 'Username',
    flex: 1,
  },
];
